// Core
import { Component, OnInit } from '@angular/core';

// Service
import { FuenteDinamicaService } from 'src/app/services/shared/fuente-dinamica/fuente-dinamica.service';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { BuscadorService } from 'src/app/services/shared/buscador/buscador.service';

// Entitys
import { Col } from '../home-searcher/data-table/Col';
import { NOMINATIVE_ATRIBUTE } from './../../../entities/shared/NominativeTitleAtribute';
import { Persona } from 'src/app/entities/shared/Persona';
import { SharedService } from 'src/app/services/shared/shared.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-nominative',
    templateUrl: './nominative.component.html',
    styleUrls: ['./nominative.component.scss'],
    standalone: false
})
export class NominativeComponent implements OnInit {

  componentName = "NominativeComponent";
  getTableConfiguration: Col[];
  getPersonaSelected: Persona;
  titleNominativeAtribute: string;
  nombreCampo: string;

  selectCountry: string;
  showTextoCopiado: boolean = false;

  stateBlock: boolean = false;
  dataBloqueoService$: Subscription;
  document: string = '';
  private lastDocumentsEntityKey: string = '';

  constructor(
    public localStorageService: LocalStorageService,
    private fuenteDinamicaService: FuenteDinamicaService,
    private sharedService: SharedService,
    private buscadorService: BuscadorService
  ) {
    this.sharedService.getdataBloqueo().subscribe({
      next: data => {
        this.stateBlock = data;
        console.log('llamado desde el nominativo', this.stateBlock);
      }
    })
  }

  ngOnInit() {
    if (this.localStorageService.getRegionSeleccionada?.getTableConfiguration()) {
      console.log('%c ' + this.componentName + " / " + 'ngOnInit()', 'background: purple; color: white');

      this.getTableConfiguration = this.localStorageService.getRegionSeleccionada.getTableConfiguration();
      this.localStorageService.getPersonaSelectedObs.subscribe(
        (persona: Persona) => {
          console.log("getPersonaSelected ----->", persona);
          this.getPersonaSelected = persona;

          const entityKey = persona?.entityKey;
          const canLoadDocuments = !!entityKey && !this.localStorageService.getIsVip;
          if (canLoadDocuments) {
            this.loadDocumentList(entityKey);
          }
        }
      );
      this.selectCountry = this.localStorageService.getRegionSeleccionada.getCode().toUpperCase();
      this.titleNominativeAtribute = this.checkNameAtribute();


      console.log('getTableConfiguration', this.getTableConfiguration);
      console.log('getPersonaSelected', this.getPersonaSelected);
      let numDocumento = this.localStorageService.getPersonaSelectedDni;
      console.log('numDocumento', numDocumento);

      if (this.selectCountry === 'AR' && this.localStorageService.getIsVip === false && !this.localStorageService.esAltaEntidades) {
        this.selectBlock(this.selectCountry);
      }
    }
  }

  private loadDocumentList(entityKey: string) {
    if (!entityKey || entityKey === this.lastDocumentsEntityKey) {
      return;
    }

    this.lastDocumentsEntityKey = entityKey;
    this.localStorageService.documentList = '';

    this.buscadorService.searchDocumentList(entityKey, { silent: true }).subscribe({
      next: listaDocuments => {
        const docs = listaDocuments?.payload?.document_list;
        if (Array.isArray(docs) && docs.length > 0) {
          this.localStorageService.documentList = docs.join('\n');
        }
      },
      error: () => {
        // Si falla, dejamos documentList vacío sin interrumpir el flujo del usuario.
      }
    });
  }

  checkNameAtribute(): string | null {
    const foundItem = this.localStorageService.getBuscadorSelect.tableConfig.find(item =>
      NOMINATIVE_ATRIBUTE.some(nomAtrib =>
        this.normalize(item.varName).includes(this.normalize(nomAtrib))
      )
    );
    this.nombreCampo = foundItem ? foundItem.varName : 'denominacion';
    return foundItem ? foundItem.varName : 'denominacion';
  }

  normalize(str: string): string {
    return str.toLowerCase().replace(/[\s_]+/g, '');
  }

  selectBlock(country: string) {
    this.fuenteDinamicaService.getDataFuenteDinamicaList(
      'NATURAL_PERSON',
      'ar_reference/data_suppression',
      country,
      'hash',
      'AR_REFERENCE/DATA_SUPPRESSION',
      '/api/v4/sources/',
      false,
      '',
      null,
      false
    ).subscribe((result: any[]) => {
      if (result.length >= 1) {
        const data = result[0];
        const ObjectData = Object.keys(data);
        const dataBoolean = [];

        ObjectData.forEach(el => {
          if (typeof data[el] === "boolean") {
            dataBoolean.push(data[el]);
          }
        })
        this.stateBlock = dataBoolean.some(x => x === true);
      } else {
        this.stateBlock = false;
      }
      this.localStorageService.bloqueoNominativo = this.stateBlock;
    })
  }

  getAttributeName(persona: any, text: string): string {
    this.localStorageService.nombreNominativo = this.sharedService.getAttributeName(persona, this.nombreCampo)
    if (this.localStorageService.nombreNominativo === undefined || this.localStorageService.nombreNominativo === null) {
      this.localStorageService.nombreNominativo = ""
    }
    const value = text.includes('.') || text.includes('[]')
      ? this.getValueByPath(persona, text)
      : undefined;
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        return value
          .flatMap(item => Array.isArray(item) ? item : [item])
          .filter(item => item !== undefined && item !== null && String(item).trim() !== '')
          .map(item => String(item).trim())
          .join(', ');
      }
      return String(value).replace(',', ', ');
    }
    return this.sharedService.getAttributeName(persona, text).replace(',', ', ');
  }

  private getValueByPath(source: any, path: string): any {
    if (!source || !path) {
      return undefined;
    }

    if (Object.prototype.hasOwnProperty.call(source, path)) {
      return source[path];
    }

    const segments = path.split('.').filter(Boolean);
    let currentValues: any[] = [source];

    for (const segment of segments) {
      const isArraySegment = segment.endsWith('[]');
      const key = isArraySegment ? segment.slice(0, -2) : segment;
      const nextValues: any[] = [];

      currentValues.forEach(current => {
        if (current === undefined || current === null) {
          return;
        }

        const value = current[key];
        if (value === undefined || value === null) {
          return;
        }

        if (isArraySegment) {
          if (Array.isArray(value)) {
            nextValues.push(...value);
          }
        } else if (Array.isArray(value)) {
          nextValues.push(...value);
        } else {
          nextValues.push(value);
        }
      });

      currentValues = nextValues;
      if (!currentValues.length) {
        return undefined;
      }
    }

    return currentValues.length === 1 ? currentValues[0] : currentValues;
  }

  copyTextToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.showTextoCopiado = true;
      setTimeout(() => {
        this.showTextoCopiado = false;
      }, 3000);
    });
  }
}
